<div class="container-fluid top-nav pt-1">
  <div class="row mt-2">
    <div class="col">
      <div class="card p-0">
        <app-orgedit [modal]="false"></app-orgedit>
      </div>
    </div>
  </div>
  <div class="card mt-3 p-3">
    <div class="row justify-content-between">
      <div class="col-3 col-sm-2 col-md text-center p-1">
        <a class="cursor-pointer opacity" matTooltip="{{ 'orgaccount.editinformation' | trans }}"
          matTooltipPosition="above" data-toggle="modal" data-target="#informationeditModal">
          <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
            create
          </span>
          <p class="mb-0 pt-1 f-13">{{ 'orgaccount.editinformation' | trans }}</p>
        </a>
      </div>
      <div class="col-3 col-sm-2 col-md text-center p-1">
        <a class="cursor-pointer opacity" matTooltip="{{ 'orgaccount.managedesign' | trans }}"
          matTooltipPosition="above" data-toggle="modal" data-target="#styleModal">
          <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
            color_lens
          </span>
          <p class="mb-0 pt-1 f-13">{{ 'orgaccount.managedesign' | trans }}</p>
        </a>
      </div>
      <div class="col-3 col-sm-2 col-md text-center p-1">
        <a class="cursor-pointer opacity" matTooltip="{{ 'orgaccount.managelogo' | trans }}" matTooltipPosition="above"
          data-toggle="modal" data-target="#logoModal">
          <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
            perm_media
          </span>
          <p class="mb-0 pt-1 f-13">{{ 'orgaccount.managelogo' | trans }}</p>
        </a>
      </div>
      <div class="col-3 col-sm-2 col-md text-center p-1">
        <a class="cursor-pointer opacity" matTooltip="{{ 'orgaccount.tagstip' | trans }}" matTooltipPosition="above"
          data-toggle="modal" data-target="#tagsModal">
          <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
            label
          </span>
          <p class="mb-0 pt-1 f-13">{{ 'orgaccount.tags' | trans }}</p>
        </a>
      </div>
      <div class="col-3 col-sm-2 col-md text-center p-1">
        <a class="cursor-pointer opacity" matTooltip="{{ 'orgaccount.notificationstip' | trans }}"
          matTooltipPosition="above" data-toggle="modal" data-target="#notificationModal">
          <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
            notifications
          </span>
          <p class="mb-0 pt-1 f-13">{{ 'orgaccount.notifications' | trans }}</p>
        </a>
      </div>
      <div class="col-3 col-sm-2 col-md text-center p-1">
        <a class="cursor-pointer opacity" matTooltip="{{ 'orgaccount.viewtemplatestip' | trans }}"
          matTooltipPosition="above" data-toggle="collapse" data-target="#collapseTemplateList">
          <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
            list
          </span>
          <p class="mb-0 pt-1 f-13">{{ 'orgaccount.viewtemplates' | trans }}</p>
        </a>
      </div>
      <div class="col-3 col-sm-2 col-md text-center p-1">
        <a class="cursor-pointer opacity" matTooltip="{{ 'orgaccount.settingstip' | trans }}" matTooltipPosition="above"
          data-toggle="modal" data-target="#settingsModal">
          <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
            settings
          </span>
          <p class="mb-0 pt-1 f-13">{{ 'orgaccount.settings' | trans }}</p>
        </a>
      </div>
      <div class="col-3 col-sm-2 col-md text-center p-1">
        <a (click)="clickAutomation()" class="cursor-pointer opacity"
          matTooltip="{{ 'orgaccount.automations' | trans }}" matTooltipPosition="above">
          <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle cursor-pointer text-secondary zoom">
            settings_suggest
          </span>
          <p class="mb-0 pt-1 f-13">{{ 'orgaccount.automations' | trans }}</p>
        </a>
      </div>
      <div class="col-3 col-sm-2 col-md text-center p-1">
        <a class="cursor-default" routerLink="/orgaccount/forms" matTooltip="{{ 'orgaccount.forms' | trans }}"
          matTooltipPosition="above">
          <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle cursor-pointer text-secondary zoom">
            app_registration
          </span>
          <p class="mb-0 pt-1 f-13">{{ 'orgaccount.forms' | trans }}</p>
        </a>
      </div>
      <div class="col-3 col-sm-2 col-md text-center p-1">
        <a class="cursor-pointer opacity" matTooltip="{{ 'orgaccount.customerwelcome' | trans }}"
          matTooltipPosition="above" data-toggle="modal" data-target="#customerwelcomemodal">
          <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
            handshake
          </span>
          <p class="mb-0 pt-1 f-13">{{ 'orgaccount.customerwelcome' | trans }}</p>
        </a>
      </div>
      <div class="col-3 col-sm-2 col-md text-center p-1">
        <a target="_blank" rel="noopener noreferrer" href="https://app.clearramp.com/support"
          class="cursor-pointer opacity" matTooltip="{{ 'orgaccount.support' | trans }}" matTooltipPosition="above">
          <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle cursor-pointer text-secondary zoom">
            help_center
          </span>
          <p class="mb-0 pt-1 f-13">{{ 'orgaccount.support' | trans }}</p>
        </a>
      </div>

      <!-- <div class="col-3 col-sm-2 col-md text-center p-1" *ngIf="hubspot">
        <a data-toggle="modal" data-target="#modalintegrations" class="cursor-default"
          matTooltip="{{ 'orgaccount.integrations' | trans }}" matTooltipPosition="above">
          <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary">
            request_quote
          </span>
          <p class="mb-0 pt-1 f-13">{{ 'orgaccount.integrations' | trans }}</p>
        </a>
      </div>-->
      <!----
        <div class="col-3 col-sm-2 col-md text-center p-1">
          <a data-toggle="modal" data-target="#modaldeals" class="cursor-default" matTooltip="Toggle deals" matTooltipPosition="above">
            <span class="material-icons p-2 bg-lightgrey f-24 rounded-circle text-secondary">
              local_offer
              </span>
              <p class="mb-0 pt-1 f-13">Deals</p>
          </a>
        </div>--->
    </div>
  </div>

  <div class="card bg-secondary collapse p-3 mt-3" id="collapseTemplateList">
    <app-orgnotificationlist></app-orgnotificationlist>
  </div>
  <div class="card bg-secondary collapse p-3 mt-3" id="collapseTemplateList">
    <app-orgtemplatelist></app-orgtemplatelist>
  </div>

  <div class="row ml-1">
    <div class="col-auto text-center p-1">
      <a class="cursor-pointer opacity" matTooltip="{{ 'orgaccount.privacypolicy' | trans }}" matTooltipPosition="above"
        href="https://clearramp.com/privacy">
        <!-----<span class="zoom bg-lightgrey p-2 f-24 rounded-circle text-secondary material-icons">
            policy
          </span>-->
        <p class="mb-0 pt-1 f-13 text-muted">{{ 'orgaccount.privacypolicy' | trans }}</p>
      </a>
    </div>
    <div class="col-auto text-center p-1">
      <a class="cursor-pointer opacity" matTooltip="{{ 'orgaccount.termsofuse' | trans }}" matTooltipPosition="above"
        href="https://clearramp.com/terms">
        <!--- <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
            gavel
          </span>-->
        <p class="mb-0 pt-1 f-13 text-muted">{{ 'orgaccount.termsofuse' | trans }}</p>
      </a>
    </div>
  </div>

  <div class="spacer"></div>

  <!-- Integrations Modal -->
  <div class="modal fade" id="modalintegrations" tabindex="-1" role="dialog" aria-labelledby="modalintegrationsztitle">
    <app-integrationsettings></app-integrationsettings>
  </div>


  <!-- Modal Settings -->
  <div class="modal fade" id="settingModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ 'orgaccount.organisationprojectsettings' | trans }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h6 class="font-weight-light">{{ 'orgaccount.defaultprojectsettings' | trans }}</h6>
          <p class="mb-0">{{ 'orgaccount.defaultprojectsettingssub' | trans }}</p>
          <div class="alert alert-danger mt-2 ml-0 mr-0" role="alert">
            {{ 'orgaccount.alert' | trans }}
          </div>
          <div class="form-check mt-3">
            <input type="checkbox" class="form-check-input">
            <label class="f-13 mb-0 font-weight-light" for="projectturnsoverdue_magicBtn">{{ 'orgaccount.nostartdate' |
              trans }}</label>
          </div>
          <div class="form-check mt-3">
            <input type="checkbox" class="form-check-input">
            <label class="f-13 mb-0 font-weight-light" for="projectturnsoverdue_magicBtn2">{{ 'orgaccount.noenddate' |
              trans }}</label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-close" data-dismiss="modal">
            <p class="btn-save-text">{{ 'orgaccount.close' | trans }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Customer welcome customize -->
  <div class="modal fade" id="customerwelcomemodal" tabindex="-1" role="dialog"
    aria-labelledby="customer welcome control">
    <app-customerwelcomeedit [isTemplate]="true"></app-customerwelcomeedit>
  </div>

  <!-- Modal ORGAUTOMATIONS -->
  <app-projectautomation [automationType]="'organization'"
    [organizationId]="automationorganizationId"></app-projectautomation>

  <!-- Modal TAGADMIN -->
  <div class="modal fade" id="tagsModal" tabindex="-1" role="dialog" aria-labelledby="Tag administration">
    <app-tagadmin></app-tagadmin>
  </div>

  <!-- Modal SETTING -->
  <div class="modal fade" id="settingsModal" tabindex="-1" role="dialog" aria-labelledby="Org Settings">
    <app-orgsettings></app-orgsettings>
  </div>

  <!-- Modal NOTIFICATION -->
  <div class="modal fade" id="notificationModal" tabindex="-1" role="dialog" aria-labelledby="Notification settings">
    <app-orgnotificationsetting></app-orgnotificationsetting>
  </div>

  <!-- Modal STYLE -->
  <div class="modal fade" id="styleModal" tabindex="-1" role="dialog" aria-labelledby="Organisation Style">
    <app-orgstyle [admin]="false"></app-orgstyle>
  </div>

  <!-- Modal Information edit -->
  <div class="modal fade" id="informationeditModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ 'orgaccount.organisationinformationedit' | trans }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <app-orgedit [modal]="true"></app-orgedit>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-close" data-dismiss="modal">
            <p class="btn-save-text">{{ 'orgaccount.close' | trans }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal logo edit -->
  <div class="modal fade" id="logoModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ 'orgaccount.managelogo' | trans }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <app-orglogo [whitelabeled]="true" [imgtype]="'rect'" [showFileDialog]="true" [modalchanger]="true"
                [orgId]="orgId"></app-orglogo>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>